import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { AppRouter } from "./routes/AppRouter";
import { AuthProvider } from "./contexts/AuthContext";
import { LoaderProvider } from "./contexts/LoaderContext";
import { AlertProvider } from "./contexts/AlertContext";
import { SocketProvider } from "./contexts/SocketContext";

import { ModalsProvider } from "./contexts/ModalsContext";
import { CustomModals } from "./components/CustomModals";

function App() {

    return (
        <BrowserRouter>
            <SocketProvider>
                <AlertProvider>
                    <LoaderProvider>
                        <AuthProvider>
                            {/* <ModalsProvider> */}
                                <CustomModals />
                                <AppRouter />
                            {/* </ModalsProvider> */}
                        </AuthProvider>
                    </LoaderProvider>
                </AlertProvider>
            </SocketProvider>
        </BrowserRouter>
    );
}

export default App;